import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Apiservice from "../Apiservice";
import Swal from "sweetalert2";
import { getCurrentUTCDate, getCurrentDate, getCurrentTime } from '../Utils/Utils'
import { useCallback } from "react";

const EOccurrenceAdd = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const loggedUserId = Number(localStorage.getItem('user_id'))
  const loggedRoleId = Number(localStorage.getItem('role_id'));
  const loggedUserType = localStorage.getItem('userType');
  const nricOrFin = localStorage.getItem('nricOrFin');



  const [attendancedUsers, setAttendancedUsers] = useState([]);
  const [userId, setUserId] = useState(loggedRoleId !== 1 && loggedUserId || 0);
  const [siteId, setSiteId] = useState(0);
  const [siteName, setSiteName] = useState("");
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const subjectRef = useRef("");
  const occurrenceRef = useRef("");
  const [site, setSite] = useState(null);

  // First effect → decide site based on role
  useEffect(() => {
    setDate(getCurrentDate());
    setTime(getCurrentTime());

    if (loggedRoleId > 1) {
      // Normal user → site from localStorage
      const storedSiteId = localStorage.getItem("siteId");
      if (storedSiteId) {
        setSite({ id: Number(storedSiteId) }); // keep structure consistent
        setSiteId(Number(storedSiteId));
      }
    } else {
      // Admin → site from navigation state
      if (location.state?.site) {
        let stateSite = location.state.site;
        setSite(stateSite);
        setSiteId(stateSite.id)
        setSiteName(stateSite.name);
      }
    }
    if (loggedUserType === 'floater') {
      setSiteId(localStorage.getItem('siteId'))
    }
  }, [loggedRoleId, location.state]);


  useEffect(() => {
    // Only fetch if date is valid and site is selected
    if (!date || !site?.id) return;

    const fetchAttendanceDetails = async () => {
      try {
        const data = {
          siteId: site.id,
          entryTime: date,
          checkTime: date + " " + time,
          status: 0
        };
        console.log("Fetching attendance for date:", date);

        const attendanceDetails = await Apiservice.GetAttendance(data);

        if (attendanceDetails.success && attendanceDetails.data?.length > 0) {
          setAttendancedUsers(attendanceDetails.data);
          console.log("Attendance Details", attendanceDetails);
        } else {
          // Only show popup if the user actually picked a date and there is no data
          // Swal.fire({
          //   title: "⚠️ Today No Staff Available",
          //   text: "Please ensure staff have checked in first.",
          //   icon: "warning",
          //   confirmButtonText: "OK",
          //   confirmButtonColor: "#8350C2",
          //   background: "#f9f9ff",
          //   color: "#333",
          // });
          // Optionally reset fields after popup
          setAttendancedUsers([]);
        }
      } catch (error) {
        console.error("Error fetching attendance:", error);
        Swal.fire("Error", "Something went wrong while fetching attendance.", "error");
      }
    };

    fetchAttendanceDetails();
  }, [date, time, site]);

  // ✅ Fetch site details when siteId changes
  useEffect(() => {
    const fetchSiteDetails = async () => {
      if (!siteId) return; // avoid unnecessary calls

      let data = {
        siteId: siteId,
        status: 0,
      };

      try {
        let siteDetails = await Apiservice.AllSites(data);
        console.log("siteDetails", siteDetails)

        if (siteDetails.success === true && siteDetails.data?.length > 0) {
          setSiteName(siteDetails.data[0].name);
        } else {
          alert("Unauthorized or No Site Found");
        }
      } catch (err) {
        console.error("Error fetching site details:", err);
      }
    };

    fetchSiteDetails();
  }, [siteId]);

  // // 👇 stable navigate function
  // const safeNavigate = useCallback((path) => {
  //   navigate(path);
  // }, [navigate]);






  const handleSave = async () => {
    // ✅ Validation

    if (loggedUserType !== 'floater') {
      if (!userId) {
        Swal.fire("Validation Error", "Please select a staff", "warning");
        return;
      }
    }


    if (!siteId) {
      Swal.fire("Validation Error", "Please select a site", "warning");
      return;
    }
    if (!date) {
      Swal.fire("Validation Error", "Please select a date", "warning");
      return;
    }
    if (!time) {
      Swal.fire("Validation Error", "Please select a time", "warning");
      return;
    }
    if (!subjectRef.current.value.trim()) {
      Swal.fire("Validation Error", "Subject cannot be empty", "warning");
      return;
    }
    if (!occurrenceRef.current.value.trim()) {
      Swal.fire("Validation Error", "Occurrence cannot be empty", "warning");
      return;
    }

    const data = {
      userType: loggedUserType,
      userId: loggedRoleId === 1 ? userId : loggedUserId,
      nricOrFin: nricOrFin,
      siteId: siteId,
      date: date,
      time: time,
      subject: subjectRef.current.value.trim(),
      occurrence: occurrenceRef.current.value.trim(),
    };

    let result = await Apiservice.OccurrenceAdd(data);
    if (result.success === true) {
      Swal.fire({
        title: result.message,
        icon: "success",
      });
      navigate("/eoccurrence");
    } else {
      Swal.fire({
        title: result.message || "Something went wrong",
        icon: "error",
      });
    }
  };

  return (
    <div className="container card shadow p-4 my-4">
      <div className="row mb-3">
        <div className="col text-end">
          <button className="btn btn-sm btn-primary" onClick={() => navigate('/eoccurrence')}>View All Occurrence</button>
        </div>
      </div>
      <h5 className="text-center mb-4">Add New Occurrence</h5>


      <div className="row g-3 mb-3">
        {/* Site */}
        <div className={loggedUserType === 'normal' ? loggedRoleId > 1 ? "col-md-6" : "col-md-3" : "col-md-6"}>
          <label className="form-label">Site</label>
          <input
            type="text"
            value={siteName}
            disabled
            className="form-control form-control-sm"
          />
        </div>
        {
          loggedRoleId == 1 && (
            <div className="col-md-3">
              <label className="form-label">Staff</label>
              <select
                className="form-select form-select-sm"
                onChange={(e) => setUserId(e.target.value)}
              >
                {attendancedUsers.length > 0 ? (
                  <>
                    <option value="">Select Staff</option>
                    {attendancedUsers.map(
                      (user) =>
                        user?.userDetails && ( // ✅ check user exists
                          <option key={user.userDetails.id} value={user.userDetails.id}>
                            {user.userDetails.firstName + " " + user.userDetails.lastName}
                          </option>
                        )
                    )}
                  </>
                ) : (
                  <option value="">No users present</option>
                )}
              </select>

            </div>
          )
        }

        {/* Date */}
        <div className="col-md-3">
          <label className="form-label">Date</label>
          <input
            type="date"
            value={date}
            // max={new Date().toISOString().split("T")[0]}
            max={getCurrentDate()}   // ✅ IMPORTANT
            className="form-control form-control-sm"
            onChange={(e) => setDate(e.target.value)}
            disabled={loggedRoleId > 1}
          />
        </div>

        {/* Time */}
        <div className="col-md-3">
          <label className="form-label">Time</label>
          <input
            type="time"
            value={time}
            className="form-control form-control-sm"
            onChange={(e) => {
              const selectedTime = e.target.value;

              // Get current local time HH:MM
              const now = new Date();
              const currentTime =
                String(now.getHours()).padStart(2, "0") + ":" +
                String(now.getMinutes()).padStart(2, "0");

              // Block future time
              if (selectedTime > currentTime) {
                alert("Future time is not allowed");
                return;
              }

              setTime(selectedTime);
            }} 
            disabled={loggedRoleId > 1}

          />

        </div>

        {/* Subject */}
        <div className="col-md-6">
          <label className="form-label">Subject</label>
          <input
            type="text"
            ref={subjectRef}
            className="form-control form-control-sm"
            placeholder="Enter subject"
          />
        </div>

        {/* Occurrence */}
        <div className="col-md-6">
          <label className="form-label">Occurrence</label>
          <input
            type="text"
            ref={occurrenceRef}
            className="form-control form-control-sm"
            placeholder="Enter occurrence"
          />
        </div>


      </div>
      {/* Save Button */}
      <div className="row">
        <div className="col-12 col-md-auto ms-md-auto">
          <button
            className="btn btn-primary btn-sm w-100 w-md-auto"
            onClick={handleSave}
          >
            Save
          </button>
        </div>
      </div>



    </div>
  );
};

export default EOccurrenceAdd;
